import * as DateRangePicker from './components/DateRangePicker.css';

export default {
	DateRangePicker
};
